export interface RefreshedOidcUser {
    access_token?: string;
}

export class OidcExplicitLogoutFence {
    private active = false;

    begin(): void {
        this.active = true;
    }

    shouldPreserveFlags(reason: string): boolean {
        return this.active && reason === 'user-unloaded';
    }
}

export function clearOidcAuthStorage(
    local: Storage,
    session: Storage,
    preserveLogoutFlags = false,
): void {
    local.removeItem('access_token');
    local.removeItem('refresh_token');
    local.removeItem('auth_token');

    const oidcKeys: string[] = [];
    for (let index = 0; index < local.length; index += 1) {
        const key = local.key(index);
        if (key?.startsWith('oidc.')) oidcKeys.push(key);
    }
    oidcKeys.forEach((key) => local.removeItem(key));

    if (!preserveLogoutFlags) {
        session.clear();
        return;
    }

    const flags = [
        'logout_initiated',
        'logout_in_progress',
        'logout_user_existed',
        'logout_error',
    ].map((key) => [key, session.getItem(key)] as const);
    session.clear();
    flags.forEach(([key, value]) => {
        if (value) session.setItem(key, value);
    });
}

export async function refreshOidcUser<T extends RefreshedOidcUser>(
    refresh: () => Promise<T | null>,
    invalidate: () => Promise<void>,
    persistAccessToken: (token: string) => void,
): Promise<T> {
    try {
        const user = await refresh();
        if (!user?.access_token) throw new Error('Silent renewal returned no access token');
        persistAccessToken(user.access_token);
        return user;
    } catch (error) {
        await invalidate();
        throw error;
    }
}
